import React from "react";

interface RepresentativeBookSectionProps {
    isMobile: boolean;
    representativeBookTitle: string;
    setRepresentativeBookTitle: (value: string) => void;
    bookTitleError?: string;
    titleRef: React.RefObject<HTMLInputElement>;
    representativeBookLink: string;
    setRepresentativeBookLink: (value: string) => void;
    bookLinkError?: string;
    linkRef: React.RefObject<HTMLInputElement>;
}

const RepresentativeBookSection: React.FC<RepresentativeBookSectionProps> = ({
    isMobile,
    representativeBookTitle,
    setRepresentativeBookTitle,
    bookTitleError,
    titleRef,
    representativeBookLink,
    setRepresentativeBookLink,
    bookLinkError,
    linkRef,
}) => {
    return (
        <label className="flex flex-col gap-4" id="authorRepresentativeBook">
            <div className="">
                <p className="title">
                    작가님의 <span className="point">대표작</span> 한 권을 소개해 주세요
                </p>
            </div>
            <div className="flex-grow">
                <div className="flex-1">
                    <p className="subTitle">작품명</p>
                    <input
                        ref={titleRef}
                        className={
                            isMobile
                                ? `appearance-none h-12 w-full font-namsan text-base border ${bookTitleError ? "border-red-500 placeholder-red-500 focus:outline-red-500" : "border-extra placeholder-[#5E676E] focus:outline-input"} rounded py-3 px-4 leading-tight focus:text-black mb-3`
                                : `appearance-none font-namsan border ${bookTitleError ? "border-red-500 placeholder-red-500 focus:outline-red-500" : "border-extra placeholder-[#5E676E] focus:outline-input"} rounded leading-tight focus:text-black mb-3`
                        }
                        style={isMobile ? {} : { width: "100%", height: "50px" }}
                        value={representativeBookTitle}
                        onChange={(e) => setRepresentativeBookTitle(e.target.value)}
                        placeholder="출간하신 책들 중 대표작 한 권을 기입해 주세요"
                    />
                    {bookTitleError && (
                        <p className="font-namsan text-[12px] font-bold text-red-500">
                            {bookTitleError}
                        </p>
                    )}
                </div>

                <div className="flex-1">
                    <p className="subTitle">작품 링크</p>
                    <input
                        ref={linkRef}
                        className={
                            isMobile
                                ? `appearance-none h-12 w-full font-namsan text-base border ${bookLinkError ? "border-red-500 placeholder-red-500 focus:outline-red-500" : "border-extra placeholder-[#5E676E] focus:outline-input"} rounded py-3 px-4 leading-tight focus:text-black`
                                : `appearance-none font-namsan border ${bookLinkError ? "border-red-500 placeholder-red-500 focus:outline-red-500" : "border-extra placeholder-[#5E676E] focus:outline-input"} rounded leading-tight focus:text-black`
                        }
                        style={isMobile ? {} : { width: "100%", height: "40px" }}
                        value={representativeBookLink}
                        onChange={(e) => setRepresentativeBookLink(e.target.value)}
                        placeholder="온라인 서점사 등 작품을 확인할 수 있는 링크를 기입해 주세요"
                    />
                </div>
                {bookLinkError && (
                    <p className="font-namsan text-[12px] font-bold text-red-500">
                        {bookLinkError}
                    </p>
                )}
            </div>
        </label>
    );
};

export default RepresentativeBookSection;
